import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pffcprwxbv: FaireBrandEntity = {
  token: "b_pffcprwxbv",
  type: "brand",
  name: "The Sunshine Sauce Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/1331c6b4a109d64e8396329cfbaa15b1b198b62e9336dea463fbb27e88915b8f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/42f4f25c711329030c4c39d4a1cb46b6cdd187251c7bef1ed05a9062bba0644e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1331c6b4a109d64e8396329cfbaa15b1b198b62e9336dea463fbb27e88915b8f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/42f4f25c711329030c4c39d4a1cb46b6cdd187251c7bef1ed05a9062bba0644e.jpeg",
  location: "Boise, ID, USA",
  minimumOrderDollars: 75,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "The Sunshine Sauce, Co. is a craft hot sauce and condiment company that's famous for its creamy garlic hot sauce. It's the perfect combination of heat and flavor that can make any dish taste even better. It all started as a personal hobby over ten years ago. Now, Sunshine Sauce has become a national sensation, loved by people all over the country who appreciate good food. Their hot sauce is carefully made in small batches and has gained a loyal following of thousands. People relish in the balanced blend of garlic and spice that adds a special touch to every meal. It's become a staple in home and restaurant kitchens alike.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:46.247Z",
    importedBy: "entity-db-cli",
  },
};
